module.exports = __webpack_public_path__ + "static/media/home-performance.3afe0c5c.png";